import React, { memo } from 'react';
import PropTypes from 'prop-types';
import doneSprite from 'assets/icons/done.svg';
import {
  SuccessPurchaseStyled,
  StyledText,
  StyledIcon,
  StyledTitle,
  Wrapper,
  ButtonsWrap,
  CircleCheck,
  InfoWrap,
  StyledButton,
} from './styles/SuccessPurchaseStyled';

const SuccessPurchase = ({
  forceDataUpdate,
  gotoPlayer,
  gotoInfo,
  toInfoText,
  toPlayerText,
  title,
  message,
  bg,
}) => {
  const onGotoPlayerClick = () => {
    forceDataUpdate();
    gotoPlayer();
  };

  const onGotoInfo = () => {
    forceDataUpdate();
    gotoInfo();
  };

  return (
    <SuccessPurchaseStyled
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <Wrapper>
        <CircleCheck>
          <StyledIcon name={doneSprite.id} size={55} />
        </CircleCheck>

        <InfoWrap>
          <StyledTitle font="din_reg" type="uppercase" color="gray_nightrider">
            {title}
          </StyledTitle>
          {message && <StyledText>{message}</StyledText>}
        </InfoWrap>
        <ButtonsWrap>
          <StyledButton
            buttonStyle="background"
            text={toPlayerText}
            textFont="din_medium"
            textColor="white"
            align="center"
            size="l"
            onClick={onGotoPlayerClick}
          />
          <StyledButton
            text={toInfoText}
            textFont="din_bold"
            textSize="fs_s"
            textColor="blue_doger"
            align="center"
            textType="uppercase"
            size="l"
            buttonStyle="transparent"
            onClick={onGotoInfo}
          />
        </ButtonsWrap>
      </Wrapper>
    </SuccessPurchaseStyled>
  );
};

SuccessPurchase.propTypes = {
  title: PropTypes.string.isRequired,
  forceDataUpdate: PropTypes.func.isRequired,
  message: PropTypes.string,
  toInfoText: PropTypes.string,
  toPlayerText: PropTypes.string,
  gotoPlayer: PropTypes.func,
  gotoInfo: PropTypes.func,
  bg: PropTypes.string,
};

SuccessPurchase.defaultProps = {
  toPlayerText: '',
  toInfoText: '',
  message: '',
  gotoInfo: Function.prototype,
  gotoPlayer: Function.prototype,
  bg: '',
};

export default memo(SuccessPurchase);
